import { MedRecSwitch, SearchHeader, StoreLocator } from '@/components';

import {
  HeaderFavorites,
  HeaderLogo,
  HeaderNavDesktop,
  HeaderProfile,
  HeaderRow,
  HeaderSection,
  HeaderShopping,
} from '../../Header.components';

const HeaderWithCenteredLogoAndBottomContentDesktop = () => (
  <>
    <HeaderRow borderless type="medium">
      <HeaderSection justify="center">
        <HeaderLogo center fullWidth />
      </HeaderSection>
    </HeaderRow>
    <HeaderRow type="small" withNavbar>
      <HeaderSection justify="start">
        <StoreLocator />
      </HeaderSection>
      <HeaderSection justify="start">
        <HeaderNavDesktop />
      </HeaderSection>
      <HeaderSection justify="end">
        <MedRecSwitch />
        <SearchHeader withEmbeddedInput />
        <HeaderProfile />
        <HeaderFavorites />
        <HeaderShopping />
      </HeaderSection>
    </HeaderRow>
  </>
);

export { HeaderWithCenteredLogoAndBottomContentDesktop };
